 import React, { useContext, useEffect } from 'react';
import { useRouter } from 'next/router'
import {
    Spinner
} from "@chakra-ui/react";
import { AllBusiness, groupedBusiness, propertyTypeOptions, provinceSlugs, subTypeOptions } from '../../../components/Listing/data';
import dynamic from 'next/dynamic'
const ListingsComp = dynamic(() => import('../../../components/listings'), { ssr: true })
import prisma from '../../../lib/prisma';
import Head from 'next/head'
import slugify from 'slugify';
import { getAreaDescriptionWithSlug } from '../../../lib/api';
import { provinceShorter } from '../../../components/ListingCard/ListingCard2point0';
import { getAsString } from '../../../src/getAsString';
import { SpinnerHolder } from '../../../styles/ListingsStyles';
import { shuffle, toProperCase } from '../../../src/apiUtility';
import { GetStaticProps } from 'next';
import { ParsedUrlQuery } from 'querystring';
import { QueryStateContext } from '../../../utils/contexts/QueryStateContext';

interface RouteParams extends ParsedUrlQuery {
    id: string
}
export type IGetStaticProps<P extends ParsedUrlQuery, Q = StaticListingPageProps> = GetStaticProps<Q, P>
type StaticTypes = 
| 'businessType'
| 'subType'
| 'propertyType'
| 'businessCategory'
| 'province'
| 'city'
export interface StaticListingPageProps {
    listings,
    countOfListings, 
    coordinates,
    startListing, 
    lastListing, 
    pages,
    listingFooterText, 
    staticType: StaticTypes, 
    staticTypeValue: string,
    currentPage, 
    description, 
    linkList1, 
    linkList2,
    linkList1Header, 
    linkList2Header, 
    staticDesc, 
    staticHeader, 
    metaDesc, 
    metaTitle, 
    cleanedVariable?, 
    cleanedName?,
    cleanedType?,
    cityListingsByPropertyType?, 
    city?
    subTypeGroup?, 
    businessTypeGroup?, 
    province?, 
    subTypeValue?, 
    propertyTypeValue?, 
    businessTypeValue?, 
    businessCategoryValue?
}

const Listings = ({ listings, countOfListings, coordinates, startListing, lastListing, pages, cityListingsByPropertyType, listingFooterText, staticType, staticTypeValue, subTypeGroup, businessTypeGroup, cleanedVariable, currentPage, description, linkList1, linkList2, linkList1Header, linkList2Header, staticDesc, staticHeader, metaDesc, metaTitle, province, subTypeValue, propertyTypeValue, businessTypeValue, businessCategoryValue }: StaticListingPageProps) => {
    const router = useRouter()
    const { id } = router.query;
    const cleanedId = getAsString(id);
    String.prototype['toProperCase'] = function () {
        return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };

    const { queryState, setQueryState } = useContext(QueryStateContext)

    useEffect(() => {
        if (Number(id)) {
            router.replace(`/listings/${cleanedId}/listing`)
        }
    }, [cleanedId])
 
    if (Number(id)) {
        return <SpinnerHolder>

            <Spinner size="xl" color="green.800" />
        </SpinnerHolder>
    }


    else {
        return (
            <>
            <Head>  
                {cleanedVariable &&
                    <>
                        <title key="title">{metaTitle}</title>
                        <meta key="og:title" 
                        property="og:title" 
                            content={metaTitle} />
                        <meta name="description" key="description"
                        content={metaDesc}/>
                        <meta key="og:description" property="og:description" content={metaDesc} />
                        <meta property='og:site_name' content='Zonado' />
                        <link key="fav1" rel="apple-touch-icon" sizes="180x180" href="../../favicons/apple-touch-icon.png" />
                        <link key="fav2" rel="icon" type="image/png" sizes="32x32" href="../../favicons/favicon-32x32.png" />
                        <link key="fav3" rel="icon" type="image/png" sizes="16x16" href="../../favicons/favicon-16x16.png" />
                        <link key="fav4" rel="manifest" href="../../favicons/site.webmanifest" />
                        <link key="fav5" rel="mask-icon" href="../../favicons/safari-pinned-tab.svg" color="#125f3f" />
                        <link key="fav6" rel="shortcut icon" href="../../favicons/favicon.ico" />
                        <link rel="canonical" href={`https://zonado.com/listings/${province ? provinceShorter(province) : slugify(cleanedVariable)}`} />
                        <meta key="msFav" name="msapplication-config" content="../../favicons/browserconfig.xml" />
                        <meta name="robots" content={countOfListings == 0 ? "noindex" : ""} />
                    </>
                }
            </Head>
                {listings ?
            <ListingsComp
                        query={{ [staticType]: [staticTypeValue] }}
                        staticType={staticType}
                        businessTypeGroup={businessTypeGroup}
                        subTypeGroup={subTypeGroup}
                        description={description ? description['description'] : null}
                        cleanedVariable={cleanedVariable}
                        linkList1={linkList1}
                        linkList2={linkList2}
                        listingFooterText={listingFooterText}
                        staticDesc={staticDesc}
                        linkList1Header={linkList1Header}
                        linkList2Header={linkList2Header}
                        cityListingsByPropertyType={cityListingsByPropertyType}
                        province={province} 
                        propertyTypeValue={propertyTypeValue}
                        businessCategoryValue={businessCategoryValue}
                        subTypeValue={subTypeValue}
                        businessTypeValue={businessTypeValue}
                        city={undefined}
                        staticData={{
                            listings,
                            countOfListings, coordinates, startListing, lastListing, pages, currentPage
                        }} 
                        cleanedProvince={cleanedVariable} 
                        cleanedType={undefined} 
                        cleanedName={undefined} 
                        staticHeader={staticHeader}               />
    
               :
                    <SpinnerHolder>

                        <Spinner size="xl" color="green.800" />
                    </SpinnerHolder>}
            </>
    
        ) 
    }

}
 
export default Listings;

export async function getStaticPaths() {


    const starterPaths = [{
        params: {
            id: 'Retail',
        }
    },
        {
            params: {
                id: 'ON',
            }
        }]
    
    return {
        paths: starterPaths,
        fallback: 'blocking'
    };
}

export function getCityListingsByPropertyType (thisProvCities, listings, province) {
    const cityListingsByPropertyType = []

    thisProvCities.forEach(({ city }) => {
        for (var a = 0; a < propertyTypeOptions.length; a++) {
            const propertyType = propertyTypeOptions[a]['value'];

            // Count number of listings where this is the province and there's overlap in property types
            const countofthisTypeinCity = listings.filter(listing => {
                if (listing.city == city && listing.propertyTypes.includes(propertyType)) {
                    return true;
                }
                return false;
            }).length;

            const propertyTypeInLowerCase = propertyType.toLowerCase()
            const suffix = 
                propertyTypeInLowerCase === 'land' ? 
                '' :
                propertyTypeInLowerCase === 'retail' ?
                'Space' :
                'Property'
            const isSaleOfBusiness = propertyTypeInLowerCase === 'sale of business'

            if (countofthisTypeinCity > 0) {
                cityListingsByPropertyType.push({ value: isSaleOfBusiness ? `Business for sale in ${city}` : `${city} ${propertyType} ${suffix}`, listingCount: countofthisTypeinCity, link: `/listings/${provinceShorter(province)}/${slugify(city)}/${slugify(propertyType)}` });
            }

        }
    })
    return cityListingsByPropertyType
}

export const generateListingFooterText = () => {
    // const isBusiness = listingPageType === 'business'
    // const isPropertyTypeOrSubType = listingPageType === 'propertyType/subType'
    // const isProvince = listingPageType === 'province'
    // const isCity = listingPageType === 'city'

    const getAorAn = (word: string) => {
        const isVowel = word.slice(0,1).toLowerCase() === 'a' || 'e' || 'i' || 'o' || 'u'
        if (isVowel) return `an ${word}`
        return `a ${word}`
    } 

    function forCityPage(city: string, province: string, countOfListings: number) {
        return [
            `Showing ${countOfListings} Business and Commercial Real Estate listings currently available near ${city}, ${provinceShorter(province)}.`,
            `Looking to purchase a business or find space for your business? Start by browsing our current list of businesses and commercial real estate for sale in ${city}. It's an excellent place to discover an opportunity to purchase a turnkey business with an established customer base or a prime commercial property.`,
            `Zonado is Canada's fastest growing commercial real estate and business marketplace online and has new listings added daily. Check back often to be amongst the first to discover new Commercial Real Estate and Business investment opportunities as they become available. View hi-res photos, listing brochures, floor plans, and more content only available here. Find public and private listings all in one place. Create a saved search to be alerted automatically.
            If you are a real estate agent or property owner with ${getAorAn(province)} Business or Commercial Real Estate listing to advertise, Zonado is here to get you the results. "Get in the Zone", and market your Business or Commercial Real Estate in Ontario to thousands of unique searchers visiting Zonado each month.`
        ]
    }
    function forProvincePage(province: string) {
        return [
            `Search through thousands of <b>Business and Commercial Real Estate listings</b> currently available for <b>sale</b> and <b>lease</b> in the province of <b>${province}</b>.`,
            `Zonado is Canada's fastest growing commercial real estate and business marketplace online and has new listings added daily. Check back often to be amongst the first to discover new commercial real estate and business investment opportunities as they become available. View hi-res photos, listing brochures, floor plans, and more content only available here. Find public and private listings all in one place.
            If you are a real estate agent or property owner with ${getAorAn(province)} Business or Commercial Real Estate listing to advertise, Zonado is here to get you the results. "Get in the Zone", and market your business or commercial real estate in ${province} to thousands of unique searchers visiting Zonado each month.`
        ]

    }
    function forBusinessPage() {
        return [
            `Search through thousands of <b>Businesses</b> currently available for <b>sale</b>.`,
            `Zonado is Canada's fastest growing commercial real estate and business marketplace online and has new listings added daily. Check back often to be amongst the first to discover new commercial real estate and business investment opportunities as they become available. View hi-res photos, listing brochures, floor plans, and more content only available here. Find public and private listings all in one place.
            If you are a real estate agent or property owner with a business listing to advertise, Zonado is here to get you the results. "Get in the Zone", and market your business to thousands of unique searchers visiting Zonado each month.`
        ]
    }
    function forPropertyTypeOrSubTypePage() {
        return [
            `Search through thousands of <b>Business and Commercial Real Estate listings</b> currently available for <b>sale</b> and <b>lease</b>`,
            `Zonado is Canada's fastest growing commercial real estate and business marketplace online and has new listings added daily. Check back often to be amongst the first to discover new commercial real estate and business investment opportunities as they become available. View hi-res photos, listing brochures, floor plans, and more content only available here. Find public and private listings all in one place.
            If you are a real estate agent or property owner with a Business or Commercial Real Estate listing to advertise, Zonado is here to get you the results. "Get in the Zone", and market your business or commercial real estate to thousands of unique searchers visiting Zonado each month.` 
        ]
    }

    return {
        forCityPage,
        forBusinessPage,
        forProvincePage,
        forPropertyTypeOrSubTypePage
    }
}

// export const sortByProListings = (listings: any[]) => {
//     const nonProListings = listings.filter(listing => !listing['User']['pro']);
//     const proListings = shuffle(listings.filter(listing => listing['User']['pro']));

//     return [...proListings, ...nonProListings];
// }

export const getStaticProps: IGetStaticProps<RouteParams> = async ({ params }) => {

    // Check if params are a number
    let cleanedVariable = params.id.replace(/-/g, ' ');
    // const isSubTypeAlsoPropertyType = cleanedVariable.includes("_")
    // const justSubType = isSubTypeAlsoPropertyType && cleanedVariable.split('_')[0]  

    const idParamIsListingID = !isNaN(Number(params.id)) // makes it a little more expressive
    const idIsProvinceSlug = provinceSlugs.some(e => e['slug'].toLowerCase() == cleanedVariable.toLowerCase())
    const propertyType = propertyTypeOptions.find(e => e['value'].toLowerCase() == cleanedVariable.toLowerCase())
    const subType = subTypeOptions
        .filter(subType => subType.group.toLowerCase() !== 'sale of business') // static pages for business categories have already being created
        .find(e => (
            e['value'].toLowerCase() == cleanedVariable.toLowerCase()) ||
            e['urlValue']?.toLowerCase() == cleanedVariable.toLowerCase()
        );
    const businessType = AllBusiness.find(e => {
        return slugify(e['value'].toLowerCase()) == slugify(cleanedVariable.toLowerCase())
    })
    const businessCategory = groupedBusiness.find(e => (
        e['urlValue']?.toLowerCase() === cleanedVariable.toLowerCase()
    ))

    // console.log("propertyType", propertyType)
    // console.log("subType", subType) 
    // console.log("businessType", businessType, cleanedVariable.toLowerCase(), slugify("")) 
    // console.log("businessCategory", businessCategory)

    if (idParamIsListingID) {
        const listingForSlug = await prisma.listing.findUnique({
            where: { id: Number(params.id) },
            select: { subject: true },
        })

        if (!listingForSlug) {
            return { notFound: true }
        }

        return {
            redirect: {
                destination: `/listings/${params.id}/${slugify(listingForSlug.subject)}`,
                permanent: true,
            }
        }
    }

    // One of the provinces
    else if (idIsProvinceSlug) {
            cleanedVariable = cleanedVariable.toUpperCase()
            // Get actual provinces
            const theProv = provinceSlugs.find(i => i['slug'].toLowerCase() == cleanedVariable.toLowerCase())
            const { value: province } = theProv;

            const listings = await prisma.listing.findMany({
                where: {
                    status: 'Available',
                    province: {
                        equals: province,
                        mode: 'insensitive'
                    }
                },
                take: 60,
                skip: undefined,
    
                select: {
                    id: true,
                    subject: true,
                    subType: true,
                    propertyTypes: true,
                    type: true,
                    priceType: true,
                    city: true,
                    showAddress: true,
                    price: true,
                    unpriced: true, 
                    offMarket: true,
                    imageOrder: true, 
                    imageURLs: true, 
                    imagesFresh: true,
                    timeStamp: true,
                    primaryImg: true,
                    bedrooms: true,
                    sqft: true,
                    lotSize: true,
                    lotSizeUnit: true,
                    cap: true,
                    province: true,
                    priority: true,
                    totalBuildingSize: true,
                    aiTagline: true,
                    distressed: true,
                    grossRevenue: true,
                    ebitda: true,
                    employees: true,
                    yearEstablished: true,
                    businessType: true,
                    businessCategory: true,
                    User: {
                        select: {
                            brokerage: true,
                            industryRole: true,
                            pro: true,
                            plan: true,
                            fullName: true,
                            photoURL: true,
                        }
                    }
                },
                orderBy:[ 
                    { priority: 'desc' },
                    { timeStamp: 'desc' },
                ]
            });
    
       
            const nonProListings = listings.filter(listing => listing['priority'] === 1);
            const proListings = shuffle(listings.filter(listing => listing['priority'] > 1));

            const proSortedListings = [...proListings, ...nonProListings];

    
            const coordinates = await prisma.listing.findMany({
                where: {
                    status: 'Available',
                    province: {
                        equals: province,
                        mode: 'insensitive'
                    }
    
                },
                select: {
                    coordinates: true,
                    id: true
                }
            });
    
            const aggregations = await prisma.listing.aggregate({
                where: {
                    status: 'Available',
                    province: {
                        equals: province,
                        mode: 'insensitive'
                    }
                },
                _count: {
                    _all: true,
                },
            })
    
            // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
            // Meaning where needs to be used in multiple places
    
            // Desctucture aggregations before returning
            const {
                _count: {
                    _all: countOfListings
                },
            } = aggregations;
    
    
            const description = await getAreaDescriptionWithSlug(cleanedVariable?.toLowerCase());
    
            // LIST OF links to include
            // Nearby properties
            const thisProvCities = await prisma.listing.groupBy({
                where: {
                    status: 'Available',
                    province: {
                        equals: province,
                        mode: 'insensitive'
                    },
                    city: {
                        not: null
                    }
                },
                by: ['city'],
                _count: {
                    _all: true,
                },
                orderBy: {
                    _count: {
                        city: 'desc'
                    },
                },    
            })
            // Types in this province
    
            
            let linkList1 = []
            const linkList1Header = `Regions in ${province}`
            thisProvCities.map(async i => {
                const { city: item, _count: {_all: itemCount} } = i
                if (item && itemCount) {
                    const formattedCityName = toProperCase(item.replace(/-/g, ' '))
                    const theObj = { item, itemCount, link: `/listings/${cleanedVariable}/${slugify(formattedCityName)}`}
                    linkList1.push(theObj);

                }
            })
    
            let newAllASubTypes = [];
            for (var a = 0; a <= propertyTypeOptions.length; a++) {

                if (a == propertyTypeOptions.length) {
                    // sort
                    newAllASubTypes.sort((a, b) => b.count - a.count);
                }

                else {

                    const type = propertyTypeOptions[a]['value'];
                    const fetchType = await prisma.listing.count({
                        where: {
                            propertyTypes: {
                                has: type
                            },
                            status: 'Available',
                            province: {
                                equals: province,
                                mode: 'insensitive'
                            },
                        },
                        // by: ['propertyTypes'],
                    })
                    newAllASubTypes.push({ type, count: fetchType });
                }

            }
            // const thisProvSubTypes = await prisma.listing.groupBy({
            //     where: {
            //         status: 'Available',
            //         province: {
            //             equals: province,
            //             mode: 'insensitive'
            //         },
            //         subType: {
            //             not: undefined
            //         }
            //     },
            //     by: ['subType'],
            //     _count: {
            //         _all: true,
            //     },
            //     orderBy: {
            //         _count: {
            //             subType: 'desc'
            //         }
            //     }
            // })
    
            let linkList2 = []
            const linkList2Header = `${province} Listing Types`
    
            // thisProvSubTypes.map(async i => {
            //     const { subType: item, _count: { _all: itemCount } } = i
            //     if (item && itemCount) {
            //         const theObj = { item, itemCount, link: `/listings/${cleanedVariable}/${slugify(item)}` }
            //         linkList2.push(theObj);
            //     }
            // })

            newAllASubTypes.map(async i => {
                const { type: item, count: itemCount } = i
                if (item && itemCount) {
                    const theObj = { item, itemCount, link: `/listings/${cleanedVariable}/${slugify(item)}` }
                    linkList2.push(theObj);
                }
            })

            const cityListingsByPropertyType = getCityListingsByPropertyType(thisProvCities, listings, province)
    
            const staticDesc = `Looking for a business or commercial real estate in ${province}? Search ${countOfListings} properties from across the province. From Land to Retail to Office properties, Zonado helps you find businesses and commercial real estate in ${province}.`
            
            const metaTitle = `${toProperCase(cleanedVariable)} Business and Commercial Real Estate listings | zonado.com`

            const metaDesc = `Search ${province} Business and Commercial Real Estate listings, review due diligence & submit offers on commercial properties. Over ${countOfListings} properties currently available.`
    
            const staticHeader = `${province} Businesses and Commercial Real Estate`

           
    
            return {
                props: {
                    cleanedVariable: province,
                    province,
                    listings: JSON.parse(JSON.stringify(proSortedListings)),
                    countOfListings,
                    coordinates,
                    description: description ? description : null,
                    linkList1,
                    linkList1Header,
                    linkList2,
                    linkList2Header,
                    startListing: 1,
                    lastListing: countOfListings > 60
                        ? 60 : countOfListings,
                    pages: Math.ceil(countOfListings / 60),
                    listingFooterText: generateListingFooterText().forProvincePage(province),
                    currentPage: 1,
                    staticType: 'province',
                    staticTypeValue: province,
                    staticDesc,
                    staticHeader,
                    metaDesc,
                    metaTitle,
                    cityListingsByPropertyType
                },
                revalidate: 3600, // In seconds
            };

    }
    // It's one of the property types
    else if (!!propertyType) {
        cleanedVariable = propertyType.value;
        const isSaleOfBusiness = propertyType.value.toLowerCase() === 'sale of business'
        const businessOrPropType = isSaleOfBusiness ? `Businesses for sale` : `${cleanedVariable} listings`
        
        const listings = await prisma.listing.findMany({
            where: {
                status: 'Available',
                propertyTypes: {
                    has: cleanedVariable
                }
            },
            take: 60,
            skip: undefined,

            select: {
                id: true,
                subject: true,
                subType: true,
                type: true,
                priceType: true,
                city: true,
                showAddress: true,
                price: true,
                unpriced: true, offMarket: true,
                imageOrder: true, imageURLs: true, imagesFresh: true,
                timeStamp: true,
                primaryImg: true,
                propertyTypes: true,
                subTypes: true,
                bedrooms: true,
                sqft: true,
                lotSize: true,
                lotSizeUnit: true,
                cap: true,
                province: true,
                priority: true,
                totalBuildingSize: true,
                aiTagline: true,
                distressed: true,
                grossRevenue: true,
                ebitda: true,
                employees: true,
                yearEstablished: true,
                businessType: true,
                businessCategory: true,
                User: {
                    select: {
                        brokerage: true,
                        industryRole: true,
                        pro: true,
                        plan: true,
                        fullName: true,
                        photoURL: true,
                    }
                }
            },
            orderBy:[ 
                { priority: 'desc' },
                { timeStamp: 'desc' },
            ] 
        });

        
        const nonProListings = listings.filter(listing => listing['priority'] === 1);
        const proListings = shuffle(listings.filter(listing => listing['priority'] > 1));

        const proSortedListings = [...proListings, ...nonProListings];
        const description = await getAreaDescriptionWithSlug(cleanedVariable?.toLowerCase());

        const coordinates = await prisma.listing.findMany({
            where: {
                status: 'Available',
                propertyTypes: {
                    has: cleanedVariable
                }
            },
            select: {
                coordinates: true,
                id: true
            }
        });

        const aggregations = await prisma.listing.aggregate({
            where: {
                status: 'Available',
                propertyTypes: {
                    has: cleanedVariable
                }
            },
            _count: {
                _all: true,
            },
        })

        // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
        // Meaning where needs to be used in multiple places

        // Desctucture aggregations before returning
        const {
            _count: {
                _all: countOfListings
            },
        } = aggregations;


        // LIST OF links to include
        // ABC listings by AREA

        const thisTypeCities = await prisma.listing.groupBy({
            where: {
                status: 'Available',
                propertyTypes: {
                    has: cleanedVariable
                },
                city: {
                    not: null
                },
                province: {
                    not: null
                }
            },
            
            by: ['city', 'province'],
            _count: {
                _all: true,
            },
            orderBy: {
                _count: {
                    city: 'desc'
                }
            }

        })

        // This property type in different regions

        let linkList1 = []
        const linkList1Header = `${businessOrPropType} by Region`
        thisTypeCities.map(async i => {
            const { city: item, province, _count: { _all: itemCount } } = i
            if (item && itemCount) {
                const formattedCityName = toProperCase(item.replace(/-/g, ' '))
                const theObj = { item, itemCount, link: `/listings/${provinceShorter(province)}/${slugify(formattedCityName)}/${slugify(cleanedVariable)}` }
                linkList1.push(theObj);
            }
        })

        const subTypesInListingPropertyType: typeof subTypeOptions = subTypeOptions.filter(subTypeOption => subTypeOption.group === cleanedVariable);
        const listingsWithSubTypesInPropType = [];
        const listingsWithOtherPropertyTypes = []
        const otherPropertyTypes = propertyTypeOptions
            .filter(propertyTypeOption => propertyTypeOption.value !== cleanedVariable)
        
        for (var a = 0; a <= subTypesInListingPropertyType.length; a++) {
            if (a == subTypesInListingPropertyType.length) {
            // sort
            listingsWithSubTypesInPropType.sort((a, b) => b.itemCount - a.itemCount);
            } else {
            const { value: subType, urlValue } = subTypesInListingPropertyType[a];
            const listingWithSubTypeCount = await prisma.listing.count({
                where: {
                status: "Available",
                subTypes: {
                    has: subType
                }
                },
                // by: ['propertyTypes'],
            });
            if (listingWithSubTypeCount > 0) {
                listingsWithSubTypesInPropType.push({
                item: subType,
                itemCount: listingWithSubTypeCount,
                link: `/listings/${slugify(urlValue || subType)}`,
                // type: subType, count: listingWithSubTypeCount 
                });
            }
            }
        }

        for (let index = 0; index <= otherPropertyTypes.length; index++) {
            if (index === otherPropertyTypes.length) {
            // sort
            listingsWithOtherPropertyTypes.sort((a, b) => b.itemCount - a.itemCount)
            } else {
            const {value: propertyType} = otherPropertyTypes[index]
            const listingsWithPropTypeCount = await prisma.listing.count({
                where: {
                propertyTypes: {
                    has: propertyType
                },
                }
            })
    
            if (listingsWithPropTypeCount > 0) {
                listingsWithOtherPropertyTypes.push({
                item: propertyType,
                itemCount: listingsWithPropTypeCount,
                link: `/listings/${slugify(propertyType)}`,
                // type: propertyType,
                // count: listingsWithPropTypeCount
                })
            }
            }
        }

        const linkList2 = [...listingsWithSubTypesInPropType, ...listingsWithOtherPropertyTypes];
        const linkList2Header = `Other Listing Types`
        
        const staticHeader = `${businessOrPropType} in Canada`
        const staticDesc = `Looking for ${businessOrPropType}? There are ${countOfListings} ${businessOrPropType} from across Canada currently available on Zonado. Sort and filter search results to find the right opportunity for you.`

        const metaTitle = `${cleanedVariable} listings in Canada | ${countOfListings} currently available | zonado.com`
        const metaDesc = `Search the latest ${businessOrPropType} from all over Canada. Review details, see photos & get broker information at zonado.com.`

       
            
        return {
            props: {
                cleanedVariable,
                propertyTypeValue: cleanedVariable,
                staticDesc,
                linkList1,
                linkList1Header,
                linkList2,
                linkList2Header,
                listings: JSON.parse(JSON.stringify(proSortedListings)),
                countOfListings,
                coordinates,
                startListing: 1,
                lastListing: countOfListings > 60
                    ? 60 : countOfListings,
                pages: Math.ceil(countOfListings / 60),
                description: description ? description : null,
                staticType: 'propertyType',
                staticTypeValue: cleanedVariable,
                listingFooterText: generateListingFooterText().forPropertyTypeOrSubTypePage(),
                metaDesc,
                metaTitle,
                staticHeader,
                currentPage: 1 },
            revalidate: 3600, // In seconds
        }

    }
        
    // It's one of the sub types
    else if (!!subType || !!businessType) {
        const { value: cleanedVariable, urlValue } = !!businessType ? businessType : subType
        const urlValueType = urlValue || cleanedVariable
        // cleanedVariable = !!businessType ? businessType.value : subType.value
        // const urlValueType = !!businessType ? businessType.value : subType.urlValue || subType.value
        const listingTypeQuery = {
            OR: [
                {
                    businessType: cleanedVariable
                },
                {
                    subTypes: {
                        has: cleanedVariable
                    }
                }
            ]
        }

        const listings = await prisma.listing.findMany({
            where: {
                status: 'Available',
                ...listingTypeQuery
            },
            take: 60,
            skip: undefined,

            select: {
                id: true,
                subject: true,
                subType: true,
                type: true,
                priceType: true,
                city: true,
                showAddress: true,
                price: true,
                unpriced: true, offMarket: true,
                imageOrder: true, imageURLs: true, imagesFresh: true,
                timeStamp: true,
                primaryImg: true,
                propertyTypes: true,
                subTypes: true,
                bedrooms: true,
                sqft: true,
                lotSize: true,
                lotSizeUnit: true,
                cap: true,
                province: true,
                priority: true,
                totalBuildingSize: true,
                aiTagline: true,
                distressed: true,
                grossRevenue: true,
                ebitda: true,
                employees: true,
                yearEstablished: true,
                businessType: true,
                businessCategory: true,
                User: {
                    select: {
                        brokerage: true,
                        industryRole: true,
                        pro: true,
                        plan: true,
                        fullName: true,
                        photoURL: true,
                    }
                }
            },
            orderBy:[ 
                { priority: 'desc' },
                { timeStamp: 'desc' },
            ]
        });

        const nonProListings = listings.filter(listing => listing['priority'] === 1);
        const proListings = shuffle(listings.filter(listing => listing['priority'] > 1));

        const proSortedListings = [...proListings, ...nonProListings];

        const description = await getAreaDescriptionWithSlug(cleanedVariable?.toLowerCase());

        const coordinates = await prisma.listing.findMany({
            where: {
                status: 'Available',
                ...listingTypeQuery
            },
            select: {
                coordinates: true,
                id: true
            }
        });

        

        const aggregations = await prisma.listing.aggregate({
            where: {
                status: 'Available',
                ...listingTypeQuery
            },
            _count: {
                _all: true,
            },
        })

        // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
        // Meaning where needs to be used in multiple places

        // Desctucture aggregations before returning
        const {
            _count: {
                _all: countOfListings
            },
        } = aggregations;


        // LIST OF links to include
        // ABC listings by AREA

        const thisTypeCities = await prisma.listing.groupBy({
            where: {
                status: 'Available',
                ...listingTypeQuery,
                city: {
                    not: null
                },
                province: {
                    not: null
                }
            },
            
            by: ['city', 'province'],
            _count: {
                _all: true,
            },
            orderBy: {
                _count: {
                    city: 'desc'
                },
            }

        })


        // This sub type in different regions

        let linkList1 = []
        const linkList1Header = `${urlValueType} listings by Region`
        thisTypeCities.map(async i => {
            const { city: item, province, _count: { _all: itemCount } } = i
            if (item && itemCount) {
                const formattedCityName = toProperCase(item.replace(/-/g, ' '))
                const theObj = { item, itemCount, link: `/listings/${provinceShorter(province)}/${slugify(formattedCityName)}/${slugify(urlValueType)}` }
                linkList1.push(theObj);
            }
        })

        let newAllASubTypes = [];
        for (var a = 0; a <= subTypeOptions.length; a++) {

            if (a == subTypeOptions.length) {
                // sort
                newAllASubTypes.sort((a, b) => b.count - a.count);
            }


            else if (subTypeOptions[a]['value'] != cleanedVariable) {

                const {value: subTypeValue, urlValue} = subTypeOptions[a];
                const fetchType = await prisma.listing.count({
                    where: {
                        status: 'Available',
                        subTypes: {
                            has: subTypeValue
                        },
                    },
                    // by: ['subTypes'],
                })
                newAllASubTypes.push({ type: urlValue || subTypeValue, count: fetchType });
            }
        }

        let linkList2 = []
        const linkList2Header = `Other Listing Types`

        newAllASubTypes.map(async i => {
            const { type: item, count: itemCount } = i
            if (item && itemCount) {
                const theObj = { item, itemCount, link: `/listings/${slugify(item)}` }
                linkList2.push(theObj);
            }
        })

        const staticHeader = `${urlValueType} listings in Canada`
        const staticDesc = `Looking for ${urlValueType} listings? There are ${countOfListings} ${urlValueType} listings from across Canada currently available on Zonado. Sort and filter search results to find the right opportunity for you.`

        const metaTitle = `${urlValueType} listings in Canada | ${countOfListings} currently available | zonado.com`
        const metaDesc = `Search the latest ${urlValueType} listings from all over Canada. Review details, see photos & get broker information at zonado.com.`


        return {
            props: {
                cleanedVariable: urlValueType,
                [!!businessType ? "businessTypeValue" : "subTypeValue"]: cleanedVariable,
                staticDesc,
                linkList1,
                linkList1Header,
                linkList2,
                linkList2Header,
                listings: JSON.parse(JSON.stringify(proSortedListings)),
                countOfListings,
                coordinates,
                startListing: 1,
                lastListing: countOfListings > 60
                    ? 60 : countOfListings,
                pages: Math.ceil(countOfListings / 60),
                description: description ? description : null,
                staticType: !!businessType ? 'businessType' : 'subType',
                staticTypeValue: cleanedVariable,
                listingFooterText: !!businessType ? generateListingFooterText().forBusinessPage() : generateListingFooterText().forPropertyTypeOrSubTypePage(),
                [!!businessType ? 'businessTypeGroup' : 'subTypeGroup']: !!businessType ? businessType.group : subType.group,
                metaDesc,
                metaTitle,
                staticHeader,
                currentPage: 1 
            },
            revalidate: 3600, // In seconds
        }
    }

    else if (!!businessCategory) {
        const { label: cleanedVariable, urlValue } = businessCategory
        const urlValueType = urlValue || cleanedVariable

        const listings = await prisma.listing.findMany({
            where: {
                status: 'Available',
                businessCategory: businessCategory.label
            },
            take: 60,
            skip: undefined,

            select: {
                id: true,
                subject: true,
                subType: true,
                type: true,
                priceType: true,
                city: true,
                showAddress: true,
                price: true,
                unpriced: true, offMarket: true,
                imageOrder: true, imageURLs: true, imagesFresh: true,
                timeStamp: true,
                primaryImg: true,
                propertyTypes: true,
                subTypes: true,
                bedrooms: true,
                sqft: true,
                lotSize: true,
                lotSizeUnit: true,
                cap: true,
                province: true,
                priority: true,
                totalBuildingSize: true,
                aiTagline: true,
                distressed: true,
                grossRevenue: true,
                ebitda: true,
                employees: true,
                yearEstablished: true,
                businessType: true,
                businessCategory: true,
                User: {
                    select: {
                        brokerage: true,
                        industryRole: true,
                        pro: true,
                        plan: true,
                        fullName: true,
                        photoURL: true,
                    }
                }
            },
            orderBy:[ 
                { priority: 'desc' },
                { timeStamp: 'desc' },
            ]  
        });

        const nonProListings = listings.filter(listing => listing['priority'] === 1);
        const proListings = shuffle(listings.filter(listing => listing['priority'] > 1));
        const proSortedListings = [...proListings, ...nonProListings];

        const description = await getAreaDescriptionWithSlug(cleanedVariable?.toLowerCase());

        const coordinates = await prisma.listing.findMany({
            where: {
                status: 'Available',
                businessCategory: businessCategory.label
            },
            select: {
                coordinates: true,
                id: true
            }
        });

        

        const aggregations = await prisma.listing.aggregate({
            where: {
                status: 'Available',
                businessCategory: businessCategory.label
            },
            _count: {
                _all: true,
            },
        })

        // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
        // Meaning where needs to be used in multiple places

        // Desctucture aggregations before returning
        const {
            _count: {
                _all: countOfListings
            },
        } = aggregations;


        // LIST OF links to include
        // ABC listings by AREA

        const thisTypeCities = await prisma.listing.groupBy({
            where: {
                status: 'Available',
                businessCategory: businessCategory.label,
                city: {
                    not: null
                },
                province: {
                    not: null
                }
            },
            
            by: ['city', 'province'],
            _count: {
                _all: true,
            },
            orderBy: {
                _count: {
                    city: 'desc'
                },
            }

        })


        // This sub type in different regions

        let linkList1 = []
        const linkList1Header = `${urlValueType} listings by Region`
        thisTypeCities.map(async i => {
            const { city: item, province, _count: { _all: itemCount } } = i
            if (item && itemCount) {
                const formattedCityName = toProperCase(item.replace(/-/g, ' '))
                const theObj = { item, itemCount, link: `/listings/${provinceShorter(province)}/${slugify(formattedCityName)}/${slugify(urlValueType)}` }
                linkList1.push(theObj);
            }
        })

        let newAllASubTypes = [];
        for (var a = 0; a <= subTypeOptions.length; a++) {

            if (a == subTypeOptions.length) {
                // sort
                newAllASubTypes.sort((a, b) => b.count - a.count);
            }


            else if (subTypeOptions[a]['value'] != cleanedVariable) {

                const { value: type, urlValue } = subTypeOptions[a];
                const fetchType = await prisma.listing.count({
                    where: {
                        status: 'Available',
                        subTypes: {
                            has: type
                        },
                    },
                    // by: ['subTypes'],
                })
                newAllASubTypes.push({ type: urlValue || type , count: fetchType });
            }
        }

        let linkList2 = []
        const linkList2Header = `Other Listing Types`

        newAllASubTypes.map(async i => {
            const { type: item, count: itemCount } = i
            if (item && itemCount) {
                const theObj = { item, itemCount, link: `/listings/${slugify(item)}` }
                linkList2.push(theObj);
            }
        })

        const businessName = cleanedVariable.toLowerCase().includes('business') ? cleanedVariable : `${cleanedVariable} Businesses`
        const staticHeader = `${businessName} for Sale in Canada`
        const staticDesc = `Looking for ${businessName}? There are ${countOfListings} ${businessName} from across Canada currently available on Zonado. Sort and filter search results to find the right opportunity for you.`

        const metaTitle = `${businessName} in Canada | ${countOfListings} currently available | zonado.com`
        const metaDesc = `Search the latest ${businessName} from all over Canada. Review details, see photos & get broker information at zonado.com.`

        return {
            props: {
                cleanedVariable: urlValueType,
                businessCategoryValue: cleanedVariable,
                staticDesc,
                linkList1,
                linkList1Header,
                linkList2,
                linkList2Header,
                listings: JSON.parse(JSON.stringify(proSortedListings)),
                countOfListings,
                coordinates,
                startListing: 1,
                lastListing: countOfListings > 60
                    ? 60 : countOfListings,
                pages: Math.ceil(countOfListings / 60),
                description: description ? description : null,
                staticType: 'businessCategory',
                staticTypeValue: cleanedVariable,
                listingFooterText: generateListingFooterText().forBusinessPage(),
                // listingSubTypeGroup: !!businessType ? businessType.group : subType.group,
                metaDesc,
                metaTitle,
                staticHeader,
                currentPage: 1 },
            revalidate: 3600, // In seconds
        }
    }
        
    else {
        return {
            notFound: true,
        }
    };
}
